<template>
  <div><GmapMap
    :center="{
        lat: content.location.position.lat,
        lng: content.location.position.lng}"
    :zoom="12">
    <GmapMarker
      :key="index"
      :position="google && new google.maps.LatLng(
        content.location.position.lat,
        content.location.position.lng)" />
  </GmapMap></div>
</template>

<script>
import Vue from 'vue'
import * as VueGoogleMaps from 'vue2-google-maps'
// import { gmapApi } from 'vue2-google-maps'

import BaseMessage from '@/layout/messages/BaseMessage.vue'

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyBJOuzulOvveitkxW97BoPcW_3qToOXoZo',
    libraries: 'places' // necessary for places input
  }
})

export default {
  name: 'ContentLocation',
  extends: BaseMessage,
  props: {
    index: {
      type: Number,
      required: true
    }
  },
  computed: {
    google: VueGoogleMaps.gmapApi
  }
}
</script>

<style lang="scss">
.vue-map-container {
  width: 300px;
  height: 300px;

  .vue-map {
    display: flex;
    height: 300px;
    overflow: auto;
    position: relative;
    width: 300px;
  }
}

div.ie11 .vue-map-container {
  width: auto;
  height: 300px;
}
</style>
